import type { ReactNode } from "react";

export interface ChatSlots {
  /** Rendered above the session list. Reserved for Tier 3 #12 Projects. */
  sidebarTop?: ReactNode;
  /** Rendered below the session list. Reserved for Tier 3 #13 scheduled tasks. */
  sidebarBottom?: ReactNode;
  /** Rendered on the right side of the header bar. */
  headerRight?: ReactNode;
  /** Rendered to the left of the composer (next to the attach button). */
  composerLeft?: ReactNode;
}

export const EMPTY_SLOTS: ChatSlots = {};
